import { assetsFetch, assetsFile, assetsUpload } from './assets.js';
import { bootstrapLedgerApply, bootstrapLedgerPreview, bootstrapSessionsApply, bootstrapSessionsPreview, bootstrapStatusApply, bootstrapStatusPreview, } from './bootstrap.js';
import { calendarCommit, calendarDiff, calendarExportFoundry, calendarGet, calendarImportFoundry, chronicleList, chronicleUnplaced, chronoPreview, clockAdvance, clockGet, clockUndo, constraintsCreate, constraintsRemove, placementsCreate, placementsList, placementsRemove, placementsUpdate, statesCreate, statesList, statesUpdate, } from './chronology.js';
import { docsCreate, docsGet, docsMeta, docsMoveBlocks, docsPatchMeta, docsPutBody, docsTitles, } from './docs.js';
import { eventsStream } from './events.js';
import { foundryImportsApply, foundryImportsCreate, foundryImportsGet, foundryImportsList, foundryImportsReject, foundryImportsUndo, foundryMacroGet, } from './foundry.js';
import { docsRestore, docsRevision, docsRevisions, docsTrash, docsUntrash, trashList, } from './history.js';
import { catalogueQuery, hygieneLinkAll, hygieneLinkAllPreview, hygieneMerge, hygieneMergePreview, inboxCapture, inboxCounts, inboxDismiss, inboxList, } from './hygiene.js';
import { importPagesGet, importPagesList, importPagesResolve, importRunsApply, importRunsCancel, importRunsComplete, importRunsCreate, importRunsDryRun, importRunsGet, importRunsList, importRunsPlan, importRunsPutMapping, importRunsUndo, importRunsUploadPart, } from './import.js';
import { knowledgeCreate, knowledgeRetract, playCreate, playForDoc, secretsForDoc, secretsList, sessionsCreate, sessionsGet, sessionsList, sessionsUpdate, } from './ledger.js';
import { linksBacklinks, linksCreate, linksCreateType, linksLint, linksList, linksRemove, linksReorder, linksTree, linksTypes, linksUpdate, } from './links.js';
import { authLogin, authLogout, authMe, gateEvidence, healthGet, healthPing, systemHealthz, } from './phase0.js';
import { referenceGet, rulesCreate, rulesGet, rulesUpdate, sheetsCreate, sheetsGet, sheetsList, sheetsUpdate, variantsCreate, } from './reference.js';
import { mentionsLink, searchPalette, searchPicker, searchUnlinked } from './search.js';
import { sessionsAttendanceGet, sessionsAttendancePut, sessionsCapturesCreate, sessionsCapturesList, sessionsCapturesPromote, sessionsCapturesRemove, sessionsCapturesUpdate, sessionsEnd, sessionsFinish, sessionsItemsCreate, sessionsItemsList, sessionsItemsMove, sessionsItemsRemove, sessionsItemsUpdate, sessionsRevealsList, sessionsSourcesList, sessionsSourcesRemove, sessionsSourcesUpload, sessionsStart, sessionsTonight, } from './sessions-2b.js';
import { sheetsCharacterGet, sheetsCharacterList, sheetsCharacterUpdate, } from './sheets-character.js';
import { docsApplyTemplate, templatesArchive, templatesCreate, templatesList, templatesUpdate, } from './templates.js';
import { docsQuarantine, docsRetype, docsRetypePreview, fieldsArchive, fieldsConvert, fieldsConvertPreview, fieldsCreate, fieldsRestore, fieldsUpdate, typesArchive, typesCreate, typesList, typesRestore, typesUpdate, } from './types.js';
import { undoApply, undoBatchesList } from './undo.js';
import { viewsCreate, viewsList, viewsPin, viewsRemove, viewsUpdate } from './views.js';
import { docsMarkOpened, docsRecent, exportsCreate, exportsFile, exportsGet, renderDoc, settingsGet, settingsUpdate, sidebarAdd, sidebarList, sidebarRemove, sidebarUpdate, } from './workspace.js';
export * from './assets.js';
export * from './bootstrap.js';
export * from './change-batch-senders.js';
export * from './chronology.js';
export * from './docs.js';
export * from './events.js';
export * from './example-ids.js';
export * from './examples.js';
export * from './examples-2b-batches.js';
export * from './examples-assets.js';
export * from './examples-chronology.js';
export * from './examples-docs.js';
export * from './examples-foundry.js';
export * from './examples-history.js';
export * from './examples-import.js';
export * from './examples-ledger.js';
export * from './examples-links.js';
export * from './examples-reference.js';
export * from './examples-sessions.js';
export * from './examples-types.js';
export * from './examples-views.js';
export * from './examples-workspace.js';
export * from './foundry.js';
export * from './history.js';
export * from './hygiene.js';
export * from './import.js';
export * from './ledger.js';
export * from './links.js';
export * from './phase0.js';
export * from './reference.js';
export * from './search.js';
export * from './sessions-2b.js';
export * from './sheets-character.js';
export * from './templates.js';
export * from './types.js';
export * from './undo.js';
export * from './views.js';
export * from './workspace.js';
/**
 * The route table: the seven frozen Phase 0 routes, then the skeleton and editor routes of
 * 1.0b's stage 1b, the event stream of its stage 2, the exit-1a routes of its stage 2b, the
 * exit-1b routes of its stage 2c, the exit-2a import routes of CS r4a and the saved-view routes of CS r4b,
 * the exit-2b session routes of CS r5a, and CS r5b's session, bootstrap and undo routes, all frozen. Frozen is not implemented: `implementedRoutes` (the `sweep` entry) keeps the routes
 * whose owner has merged.
 *
 * The table's order is the order to mount in: a route whose literal segment another route of the
 * same method matches with a parameter comes first (`docs.recent` before `docs.get`), which
 * `assertRouteTable` checks, because Hono and MSW both answer with the first route that matches.
 */
export const routes = Object.freeze([
    systemHealthz,
    authLogin,
    authLogout,
    authMe,
    healthGet,
    healthPing,
    gateEvidence,
    docsCreate,
    docsRecent,
    docsGet,
    docsPutBody,
    docsPatchMeta,
    docsMeta,
    docsTitles,
    docsMoveBlocks,
    searchPicker,
    assetsUpload,
    assetsFetch,
    assetsFile,
    eventsStream,
    docsRevisions,
    docsRevision,
    docsRestore,
    docsTrash,
    docsUntrash,
    trashList,
    docsMarkOpened,
    typesList,
    typesCreate,
    typesUpdate,
    typesArchive,
    typesRestore,
    fieldsCreate,
    fieldsUpdate,
    fieldsArchive,
    fieldsRestore,
    fieldsConvertPreview,
    fieldsConvert,
    docsRetypePreview,
    docsRetype,
    docsQuarantine,
    linksTypes,
    linksCreateType,
    linksList,
    linksCreate,
    linksUpdate,
    linksRemove,
    linksReorder,
    linksLint,
    linksBacklinks,
    linksTree,
    searchPalette,
    searchUnlinked,
    mentionsLink,
    templatesList,
    templatesCreate,
    templatesUpdate,
    templatesArchive,
    docsApplyTemplate,
    settingsGet,
    settingsUpdate,
    sidebarList,
    sidebarAdd,
    sidebarUpdate,
    sidebarRemove,
    renderDoc,
    exportsCreate,
    exportsGet,
    exportsFile,
    calendarGet,
    calendarDiff,
    calendarCommit,
    calendarImportFoundry,
    calendarExportFoundry,
    chronoPreview,
    placementsList,
    placementsCreate,
    placementsUpdate,
    placementsRemove,
    constraintsCreate,
    constraintsRemove,
    chronicleList,
    chronicleUnplaced,
    clockGet,
    clockUndo,
    clockAdvance,
    statesList,
    statesCreate,
    statesUpdate,
    secretsList,
    secretsForDoc,
    knowledgeCreate,
    knowledgeRetract,
    playCreate,
    playForDoc,
    sessionsCreate,
    sessionsList,
    sessionsGet,
    sessionsUpdate,
    catalogueQuery,
    inboxList,
    inboxCounts,
    inboxDismiss,
    inboxCapture,
    hygieneMergePreview,
    hygieneMerge,
    hygieneLinkAllPreview,
    hygieneLinkAll,
    referenceGet,
    rulesGet,
    sheetsGet,
    sheetsList,
    sheetsCreate,
    sheetsUpdate,
    variantsCreate,
    importRunsCreate,
    importRunsUploadPart,
    importRunsComplete,
    importRunsList,
    importRunsGet,
    importRunsPlan,
    importRunsCancel,
    importRunsPutMapping,
    importRunsDryRun,
    importPagesList,
    importPagesGet,
    importPagesResolve,
    importRunsApply,
    importRunsUndo,
    sessionsItemsList,
    sessionsItemsCreate,
    sessionsItemsUpdate,
    sessionsItemsMove,
    sessionsItemsRemove,
    sessionsAttendanceGet,
    sessionsAttendancePut,
    sessionsCapturesList,
    sessionsCapturesCreate,
    sessionsCapturesUpdate,
    sessionsCapturesRemove,
    sessionsStart,
    sessionsEnd,
    sessionsFinish,
    sessionsTonight,
    viewsList,
    viewsCreate,
    viewsUpdate,
    viewsRemove,
    viewsPin,
    sessionsCapturesPromote,
    sessionsSourcesList,
    sessionsSourcesUpload,
    sessionsSourcesRemove,
    sessionsRevealsList,
    bootstrapSessionsPreview,
    bootstrapSessionsApply,
    bootstrapStatusPreview,
    bootstrapStatusApply,
    bootstrapLedgerPreview,
    bootstrapLedgerApply,
    undoBatchesList,
    undoApply,
    // CS r6a (deliverables 183 and 185): the character sheets, then the Foundry import.
    sheetsCharacterGet,
    sheetsCharacterList,
    sheetsCharacterUpdate,
    foundryImportsCreate,
    foundryImportsList,
    foundryImportsGet,
    foundryImportsReject,
    foundryImportsApply,
    foundryImportsUndo,
    foundryMacroGet,
    // CS r6c (deliverable 202): the card writes, owner 2.M, stage s1.
    rulesCreate,
    rulesUpdate,
]);
const byId = new Map(routes.map((route) => [route.id, route]));
/** The route with this id; throws on an unknown id. */
export function getRoute(id) {
    const route = byId.get(id);
    if (!route)
        throw new RangeError(`unknown route id "${id}"`);
    return route;
}
//# sourceMappingURL=index.js.map